module.exports = __webpack_public_path__ + "media/src/internal/images/icons/hamburger-3d03f2a214cdb25003c57a5458758e86.svg";